import type { StateCreator } from 'zustand';

export interface IResetPasswordSlice {
  resetPasswordSlice: {
    email: string;
    requestMfaType: string;
    customerId: string;
    mfaDestination: string;
    stateToken: string;
    token: string;
    isUs: boolean;
    setEmail: (email: string) => void;
    setRequestMfaType: (requestMfaType: string) => void;
    setCustomerId: (customerId: string) => void;
    setMfaDestination: (mfaDestination: string) => void;
    setStateToken: (stateToken: string) => void;
    setToken: (token: string) => void;
    setIsUs: (isUs: boolean) => void;
    clearSlice: () => void;
  };
}

const initSliceData = {
  email: '',
  requestMfaType: '',
  customerId: '',
  mfaDestination: '',
  stateToken: '',
  token: '',
  isUs: false,
};

export const createResetPasswordSlice: StateCreator<IResetPasswordSlice> = (set) => ({
  resetPasswordSlice: {
    ...initSliceData,
    setEmail: (email: string) =>
      set((state) => ({
        resetPasswordSlice: { ...state.resetPasswordSlice, email },
      })),
    setRequestMfaType: (requestMfaType: string) =>
      set((state) => ({
        resetPasswordSlice: { ...state.resetPasswordSlice, requestMfaType },
      })),
    setCustomerId: (customerId: string) =>
      set((state) => ({
        resetPasswordSlice: { ...state.resetPasswordSlice, customerId },
      })),
    setMfaDestination: (mfaDestination: string) =>
      set((state) => ({
        resetPasswordSlice: { ...state.resetPasswordSlice, mfaDestination },
      })),
    setStateToken: (stateToken: string) =>
      set((state) => ({
        resetPasswordSlice: { ...state.resetPasswordSlice, stateToken },
      })),
    setToken: (token: string) =>
      set((state) => ({
        resetPasswordSlice: { ...state.resetPasswordSlice, token },
      })),
    setIsUs: (isUs: boolean) =>
      set((state) => ({
        resetPasswordSlice: { ...state.resetPasswordSlice, isUs },
      })),
    clearSlice: () =>
      set((state) => ({
        resetPasswordSlice: {
          ...state.resetPasswordSlice,
          ...initSliceData,
        },
      })),
  },
});
